import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CustomerCode } from '../interfaces/customercode.interface';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerCodeService {

  private getcustomercodesUrl = environment.apiUrl + '/handlers/customercodegetall.php';
  customercodes: CustomerCode[] = [];

  constructor(private http: HttpClient) { }

  async getCustomercodes(): Promise<CustomerCode[]> {
    let cuser = localStorage.getItem('currentUser');
    if (cuser === null) {
      throw new Error('Not logged in');
    }
    let user = JSON.parse(cuser);
    let distid = user['distid'];
    const data$ = this.http.post<CustomerCode[]>(this.getcustomercodesUrl,JSON.stringify({ distid: distid }))
    try {
          this.customercodes = await firstValueFrom(data$);
          return this.customercodes;
        }
        catch (error) {
          console.error('getcustomercodes!', error);
          throw error;
        };  
  }
    
}
